module.exports = "https://cdn.hellotech.com/client-assets/shelf_install_084b147d40d0af5442774359581cb18a.png";